import StudentPng from '../assets/student.png';
import BookPng from '../assets/book.png';
import AfricaPng from '../assets/africa.png';
import MedicinePng from '../assets/medicine.png';
import PersonalizedPng from '../assets/personalized.png';

function InfiniteScrollSectionTwo() {
  const infiniteScrollContent = [
    {
      imgUrl: BookPng,
      key: 1,
    },

    {
      imgUrl: StudentPng,
      key: 2,
    },

    {
      imgUrl: AfricaPng,
      key: 3,
    },

    {
      imgUrl: MedicinePng,
      key: 4,
    },

    {
      imgUrl: PersonalizedPng,
      key: 5,
    },
  ];

  const width = '250px';
  const quantity = infiniteScrollContent.length;

  return (
    <div
      className="infinite-slider h-12 overflow-hidden w-full"
      style={{
        '--width': width,
        '--quantity': quantity,
      }}
    >
      <div className="list w-full h-full flex gap-2 md:gap-4 items-center relative">
        {infiniteScrollContent.map((item) => {
          const { imgUrl, key } = item;

          return (
            <div
              className="flex w-full items-center justify-center h-10 item right-full animate-autoRunLTR"
              key={key}
              style={{
                '--position': key,
                animationDelay:
                  'calc((10s / var(--quantity)) * (var(--position) - 1) - 10s)',
              }}
            >
              <img src={imgUrl} alt="" />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default InfiniteScrollSectionTwo;
